/**
 * @file FooterScriptsSlot.tsx
 *
 * @fileoverview Prints custom scripts on the site head.
 */

import React from 'react';
import FacebookPixel from '~/components/FacebookPixel';

export const FooterScriptsSlot = () => {
  return (
    <>
      <FacebookPixel />
    </>
  );
};
export default FooterScriptsSlot;
